import axios from "axios";

const getExisteNumeroSobre = async (NumeroSobre) => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const userData = {
    nic: formattedNic,
    token: token,
    numeroSobre: NumeroSobre,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Transferencias/DeterminarSiExisteNumeroSobre`, userData);
  return response.data;
};

const existeNumeroSobre = {
  getExisteNumeroSobre,
};

export default existeNumeroSobre;
